export default __webpack_public_path__ + "static/media/thank-you-promo.bee0ebd0.png";